// token given by backend for session
export const SAMPARKTOKEN = 'ApplicationToken';
// token given for temporary use - signupform
export const TEMPTOKEN = 'tempToken';
// token to store logged in user details
export const LOGGEDINUSERINFOTOKEN = 'loggedInUserInfoToken';
